// extracted by mini-css-extract-plugin
module.exports = {"input":"datepicker_input__bgOx_"};